import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";
import InternetRegistrationsModal from "./internet-registrations-modal.component";
import { ConversationFiltersButton } from "../ConversationFilters/styles";
import { getAccessToken } from "../../helpers/functions";
import { useQuery } from "@apollo/client";
import { GET_LATEST_MESSAGE, GET_INTERNET_REGISTRATIONS_CONFIG } from "./query";
import { Tooltip } from "react-tooltip";

const InternetRegistrations = ({ conversationId }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { addToast } = useToasts();

	const { data: configData, loading: configLoading } = useQuery(
		GET_INTERNET_REGISTRATIONS_CONFIG
	);
	const isConfigEnabled = !!(
		configData &&
		configData.msgbox_Configuration &&
		configData.msgbox_Configuration[0] &&
		configData.msgbox_Configuration[0].IsReapitInternetRegistrationsEnabled
	);

	// get latest message for the conversation
	const { data, loading } = useQuery(GET_LATEST_MESSAGE, {
		variables: { conversationId },
		skip: !conversationId,
	});

	let hasRecentMessage = false;
	if (data && data.msgbox_Message && data.msgbox_Message.length > 0) {
		const latest = data.msgbox_Message[0].DateTime;
		hasRecentMessage =
			Date.now() - new Date(latest).getTime() < 3 * 24 * 60 * 60 * 1000;
	}

	const handleButtonClick = () => {
		setIsModalOpen(true);
	};

	const handleModalClose = () => {
		setIsModalOpen(false);
	};

	const handleSubmit = async (formData) => {
		try {
			const token = await getAccessToken();

			const response = await fetch(
				`${process.env.REACT_APP_API_URL}utilities/internetregistration`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({
						conversationId: conversationId,
						enquiryType: formData.enquiryType,
						officeId: formData.officeId,
					}),
				}
			);

			if (response.ok) {
				addToast("Internet registration sent successfully!", {
					appearance: "success",
					autoDismiss: true,
				});
				setIsModalOpen(false);
			} else {
				const errorData = await response.json();
				addToast(
					`Error: ${
						errorData.message ||
						"Failed to send internet registration"
					}`,
					{
						appearance: "error",
						autoDismiss: true,
					}
				);
			}
		} catch (error) {
			console.error("Error sending internet registration:", error);
			addToast("Error: Failed to send internet registration", {
				appearance: "error",
				autoDismiss: true,
			});
		}
	};

	if (configLoading) return null;
	if (!isConfigEnabled) {
		return null;
	}

	return (
		<>
			<ConversationFiltersButton
				data-tooltip-id="internet-registrations-tooltip"
				data-tooltip-content="Send to Internet Registrations"
				icon="fas fa-globe"
				onClick={handleButtonClick}
				disabled={!hasRecentMessage}
			/>
			<Tooltip id="internet-registrations-tooltip" place="top" />
			<InternetRegistrationsModal
				isOpen={isModalOpen}
				onClose={handleModalClose}
				onSubmit={handleSubmit}
			/>
		</>
	);
};

export default InternetRegistrations;
